import { OrderlineType } from '~/Models/DTO/Orderline.models';
import { OverflowingMenuItem, OverflowMenuItemType } from '~/Components';
import { IBookingSimple, PresenceType, BookingStatus } from '~/Models/DTO/Booking.models';
import { useLanguage } from '~/Hooks';

interface IUseMenuItems {
  hasManualBookingAccess: boolean;
  handleBookingUpdate: () => void;
  handleActionButton: () => void;
  handleAddProduct: () => void;
  setShowRefundModal: Function;
  updateBookingStatus: Function;
  booking: IBookingSimple;
  productType: string;
  viewMode: boolean;
}
export const useMenuItems = ({
  booking,
  hasManualBookingAccess,
  handleBookingUpdate,
  handleActionButton,
  handleAddProduct,
  setShowRefundModal,
  updateBookingStatus,
  productType,
  viewMode,
}: IUseMenuItems) => {
  const { t } = useLanguage();
  const menuItems: OverflowingMenuItem[] = [];
  if (
    (booking.presenceType === PresenceType.NONE || booking.presenceType === PresenceType.ABSENT) &&
    hasManualBookingAccess
  ) {
    if (booking.status === BookingStatus.BOOKED) {
      menuItems.push({
        label: t('app.checkin'),
        onClick: handleActionButton,
        type: OverflowMenuItemType.PRIMARY,
      });
    } else {
      menuItems.push({
        label: t('app.book'),
        onClick: handleActionButton,
        type: OverflowMenuItemType.PRIMARY,
        hide: viewMode,
      });
    }
  }
  if (booking.status !== BookingStatus.CANCELLED) {
    menuItems.push({
      label: t('app.product.addProduct'),
      onClick: handleAddProduct,
      type: booking.orderLine?.text
        ? OverflowMenuItemType.ALWAYS_HIDDEN
        : OverflowMenuItemType.SECONDARY,
    });
    if (booking.status === BookingStatus.WAITING_LIST) {
      menuItems.push({
        label: t('app.booking.book'),
        onClick: handleBookingUpdate,
        type: OverflowMenuItemType.PRIMARY,
      });
    } else {
      menuItems.push({
        label: t('app.booking.cancel'),
        onClick: () => {
          const needToggleRefund: string[] = [
            OrderlineType.CREDITPASS,
            OrderlineType.SINGLEEVENT,
            OrderlineType.COURSE,
          ];
          if (needToggleRefund.includes(productType)) {
            setShowRefundModal(true);
          } else {
            updateBookingStatus(booking, BookingStatus.CANCELLED);
          }
        },
        type: OverflowMenuItemType.ALWAYS_HIDDEN,
      });
    }
  }

  if (booking.status === BookingStatus.WAITING_LIST) {
    menuItems.push({
      label: t('app.booking.cancel'),
      onClick: () => updateBookingStatus(booking, BookingStatus.CANCELLED),
      type: OverflowMenuItemType.ALWAYS_HIDDEN,
    });
  }
  return menuItems;
};
